import RootState from 'typings/RootState';

export const messageSelector = (state: RootState): string =>
  state.login.message ? state.login.message : '';
